<template>
  <div class="cnt-info-root" v-if="user">
    <img class="img-banner" src="../../assets/b2c-img-refer-top.png">
    <a class="txt-name">
      <div v-if="user.enable && user.special">
        <b class="name">You're invited</b> to<br>join StoreCash. Sign up<br>now <b>to claim your </b><a
          class="camount">$5</a>
      </div>
      <div v-else>
        <b class="name">{{ user.first_name }}</b> invited you to<br>join StoreCash! <a class="cmessage"
          v-if="user.referral_campaign.enabled"><br>Join now and get upto<a class="camount"> ${{
            user.referral_campaign.amt
          }}</a></a>
      </div>

    </a>
    <!-- a v-if="user.referral_campaign.enabled" class="campaign-message">{{ user.referral_campaign.message }}</!-->
    <a class="btn-install" :href="user.referral_link_firebase">Install App</a>
    <a class="txt-referral-cash">
      <div v-if="user.enable && user.special">
        Once you sign up, spend $20<br> within a week & get $5 FREE!
      </div>
      <div v-else>
        Once you sign up, you can invite your friends & earn free referral cash!
      </div>      
    </a>
    <div class="campaign-terms" v-if="user.referral_campaign && user.referral_campaign.terms">
      <a class="title"><i>Terms & Conditions</i></a>
      <div class="terms">{{ user.referral_campaign.terms }}</div>
    </div>
    <img v-if="user.enable && user.special" class="img-ig_growth" src="../../assets/b2c-img-ig_growth.png">
  </div>
</template>

<script>
import API from "../../modules/api";

export default {
  name: "b2c-view-info",

  data: function () {
    return {
      processing: false,
      user: null
    };
  },

  mounted: function () {
    const vm = this;
    vm.init();
  },

  methods: {
    // Fetch Details
    init: async function () {
      const vm = this;
      try {
        vm.processing = true;
        vm.user = await API.b2c.referral.getInfo(vm.$route.params.id);
      } catch (err) {
        // Todo
      } finally {
        vm.processing = false;
      }
    }
  }
};
</script>

<style>
.cnt-info-root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 90vh;
  background: #FFFFFF;
}

.img-banner {
  width: 100%;
  height: auto;
}
.img-ig_growth {
  padding: 0px 20px 20px 20px;
  width: 75%;
  height: auto;
}

.txt-name {
  padding: 30px 40px 20px 40px;
  width: 100%;
  color: #434343;
  font-size: 22px;
  text-align: center;
}

.name {
  text-transform: capitalize;
}

.txt-referral-cash {
  padding: 20px;
  text-align: center;
  font-weight: 800;
  font-size: 20px;
  color: #1BC28D;
}

.cmessage {
  color: #434343
}

.camount {
  font-size: 23px;
  font-weight: 800;
  color: #1BC28D;
}

.btn-install {
  padding: 10px;
  border-radius: 50px;
  border: none;
  display: block;
  text-decoration: none;
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  width: 75%;
  background: linear-gradient(90deg, #05b951, #33cccc);
  font-weight: 800;
  font-size: 20px;
}

.btn-install:hover {
  box-shadow: 0 4px 4px 0 #DADADA
}

.campaign-message {
  padding: 0px 40px 0px 40px;
  width: 100%;
  color: #95989A;
  font-size: 16px;
  text-align: center;
  white-space: pre-line;
}

.campaign-terms {
  padding: 0px 40px 30px 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
}

.title {
  padding: 0px 0px 20px 0px;
  color: #434343;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  text-decoration: underline;
  white-space: pre-line;
}

.terms {
  color: #434343;
  padding: 0px 16px 16px 16px;
  font-size: 16px;
  white-space: pre-line;
}

@media (min-width: 1100px) {
  #app {
    margin-right: 34%;
    margin-left: 34%;
  }
}
</style>

<!-- <style lang="sass" scoped>

@import "../../assets/default.sass"

.cnt-info-root
  display: flex
  flex-direction: column
  justify-content: flex-start
  align-items: center
  width: 100%
  min-height: 90vh
  background: #FFFFFF

  .img-banner
    width: 100%
    height: auto

  .txt-name
    padding: 30px 40px 0px 40px
    width: 100%
    color: #434343
    font-size: 22px
    text-align: center

    .name
      text-transform: capitalize

    .cmessage
      color: #434343

    .camount
      font-size: 23px
      font-weight: 800
      color: #1BC28D

  .btn-install
    cursor: pointer
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 30px 40px 30px 40px
    height: 35px
    width: 220px
    color: #FFFFFF
    font-size: 16px
    font-weight: 600
    text-decoration: none
    background: rgba(27, 194, 141, 1)
    background: linear-gradient(90deg, rgba(27, 194, 141, 1) 0%, rgba(51, 204, 204, 1) 100%)
    border: 0px solid
    border-radius: 20px
    box-shadow: 0 2px 2px 0 #DADADA

  .btn-install:hover
    box-shadow: 0 4px 4px 0 #DADADA

  .campaign-message
    padding: 0px 40px 0px 40px
    width: 100%
    color: #95989A
    font-size: 16px
    text-align: center
    white-space: pre-line

  .campaign-terms
    padding: 0px 40px 30px 40px
    width: 100%
    display: flex
    flex-direction: column
    justify-content: center

    .title
      color: #434343
      font-size: 13px
      font-weight: 400
      text-align: center
      text-decoration: underline
      white-space: pre-line

    .terms
      color: #434343
      font-size: 13px
      white-space: pre-line

</style> -->
